import css from './index.less'

/*注意 default 关键字全部用小写，即便控制的action方法是小驼峰*/
export default {
  index: resolve => require.ensure([], ()=>{resolve(require('./base'))}, 'pages'),
  hall: resolve => require.ensure([], ()=>{resolve(require('./hall'))}, 'pages'),
  detail: resolve => require.ensure([], ()=>{resolve(require('./detail'))}, 'pages'),
  develop: resolve => require.ensure([], ()=>{resolve(require('./develop'))}, 'pages'),
  order: resolve => require.ensure([], ()=>{resolve(require('./order'))}, 'pages'),
  customize: resolve => require.ensure([], ()=>{resolve(require('./customize'))}, 'pages'),
  aboutus: resolve => require.ensure([], ()=>{resolve(require('./aboutus'))}, 'pages'),
  customcase: resolve => require.ensure([], ()=>{resolve()}, 'pages'),
}


// WEBPACK FOOTER //
// ./src/pages/base/index.js